<div class="credit-worthiness-check-capture-container document-capture-container">
  @if (document.isSubmitted === false) {
    <div class="download-container">
      <div class="file-title">Download Your Credit Worthiness</div>
      <div class="download-form">
        <button
          class="primary-action-btn"
          id="btn-download"
          matRipple
          [matRippleCentered]="true"
          [matRippleDisabled]="false"
          [matRippleUnbounded]="false"
          (click)="downloadDocument()"
          >
          @if (!isDownloadInProgress) {
            <span>Download</span>
          }
          @if (isDownloadInProgress) {
            <span>Downloading...</span>
          }
          @if (!isDownloadInProgress) {
            <span class="material-symbols-outlined">
              download
            </span>
          }
        </button>
      </div>
    </div>
  }

  @if (document.errorMessage) {
    <div class="error-message">
      {{ document.errorMessage }}
      <button (click)="closeErrorMessage()">
        <span class="material-symbols-outlined"> close </span>
      </button>
    </div>
  }
  <app-generic-document-capture
      [instructions]="instructions"
      [enableSubmitButton]="document.enableSubmitButton"
      [enableUploadButton]="document.enableUploadButton"
      (onFileUploaded)="onUploadDocument($event)"
      (onCleaned)="onCleanDocument($event)"
      (onSubmitted)="onSubmittedDocument($event)"
    ></app-generic-document-capture>

  
</div>
